import React, { useState, useEffect } from "react";
import contentData from "../content.json";
import { Fade } from "react-awesome-reveal";

/* ==========================================
*   JSON Template Example
*  ==========================================

  "repo_stats": {
    "section": {
      "enable_section": true
    },
    "repo_link": "https://gitlab.com/username/repo",
    "api_link": "https://gitlab.com/api/v4/projects/projectId"
  },

  * "enable_section": <true or false> to enable/disable section
  * "repo_link": "GitLab link to your repo (gitlab.com/...)" 
  * "api_link": "GitLab API link with project ID (gitlab.com/api/v4/projects/...)"

*/

const RepoStats = () => {
  const [repoData, setRepoData] = useState({});
  const [hidden, setHidden] = useState(false);
  const [totalCommits, setTotalCommits] = useState(0);

  useEffect(() => {
    // GitLab API endpoint
    const apiUrl = contentData.repo_stats.api_link;

    // Fetch repository data
    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setRepoData(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    // Fetch commit count
    fetch(`${apiUrl}/repository/commits`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setTotalCommits(data.length);
      })
      .catch((error) => {
        console.error("Error fetching commit statistics:", error);
      });

    // Event listener for scrolling
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to handle scroll behavior
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  };

  function commitUrl(input, attachment) {
    return `${input}${attachment}`;
  }

  const commit_link = commitUrl(
    contentData.repo_stats.repo_link,
    "/-/commits/main"
  );
  const last_commit_link = commitUrl(
    contentData.repo_stats.repo_link,
    "/-/commit"
  );

  return (
    <div className={`repo-stats ${hidden ? "hidden" : ""}`}>
      <Fade direction="down" triggerOnce={true}>
        <p>
          <a
            href={contentData.repo_stats.repo_link}
            target="_blank"
            rel="noreferrer"
          >
            Repo Name: {repoData.name}
          </a>{" "}
          •{" "}
          <a
            href={contentData.general.navbar_social_links.gitlab}
            target="_blank"
            rel="noreferrer"
          >
            Author: {repoData.namespace?.name}
          </a>{" "}
          •{" "}
          <a href={commit_link} target="_blank" rel="noreferrer">
            Total Commits: {totalCommits}
          </a>{" "}
          •{" "}
          <a href={last_commit_link} target="_blank" rel="noreferrer">
            Last Push: {new Date(repoData.last_activity_at).toLocaleString()} CST
          </a>
        </p>
      </Fade>
    </div>
  );
};

export default RepoStats;
